import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { setFeature } from "@smithy/core";
import { getSmithyContext } from "@smithy/util-middleware";
import { getEndpointFromInstructions } from "./adaptors/getEndpointFromInstructions";
export var endpointMiddleware = function endpointMiddleware(_ref) {
  var config = _ref.config,
    instructions = _ref.instructions;
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var _endpoint$properties, _context$authSchemes;
        var endpoint, authScheme, _smithyContext$select, smithyContext, httpAuthOption;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (config.endpoint) {
                  setFeature(context, "ENDPOINT_OVERRIDE", "N");
                }
                _context.next = 3;
                return getEndpointFromInstructions(args.input, {
                  getEndpointParameterInstructions: function getEndpointParameterInstructions() {
                    return instructions;
                  }
                }, _objectSpread({}, config), context);
              case 3:
                endpoint = _context.sent;
                context.endpointV2 = endpoint;
                context.authSchemes = (_endpoint$properties = endpoint.properties) === null || _endpoint$properties === void 0 ? void 0 : _endpoint$properties.authSchemes;
                authScheme = (_context$authSchemes = context.authSchemes) === null || _context$authSchemes === void 0 ? void 0 : _context$authSchemes[0];
                if (authScheme) {
                  context["signing_region"] = authScheme.signingRegion;
                  context["signing_service"] = authScheme.signingName;
                  smithyContext = getSmithyContext(context);
                  httpAuthOption = smithyContext === null || smithyContext === void 0 ? void 0 : (_smithyContext$select = smithyContext.selectedHttpAuthScheme) === null || _smithyContext$select === void 0 ? void 0 : _smithyContext$select.httpAuthOption;
                  if (httpAuthOption) {
                    httpAuthOption.signingProperties = Object.assign(httpAuthOption.signingProperties || {}, {
                      signing_region: authScheme.signingRegion,
                      signingRegion: authScheme.signingRegion,
                      signing_service: authScheme.signingName,
                      signingName: authScheme.signingName,
                      signingRegionSet: authScheme.signingRegionSet
                    }, authScheme.properties);
                  }
                }
                return _context.abrupt("return", next(_objectSpread({}, args)));
              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
  };
};